/**
 * Parcels Details
 */

// React
import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../../../redux/reducers';
import {
  getLogsAction,
  getParcelsWithIdAction,
  getParcelInventoryItemsAction,
  cleanPercelInventoryItemsAction,
  getInventoryItemsWithSerialAction,
} from '../../../parcels/actions';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectLogs,
  makeSelectParcel,
  makeSelectLoading,
  makeSelectError,
  makeSelectInventoryItemsList,
  makeSelectInventoryItemsLoading,
  makeSelectInventoryItemsCount,
  makeSelectInventoryItemsWithSerialList,
  makeSelectInventoryItemsWithSerialLoading,
} from '../../../parcels/selectors';
import {
  Typography,
  Paper,
  Grid,
  Box,
  Card,
  CardHeader,
  CardContent,
  Tabs,
  Tab,
  FormControl,
  MenuItem,
  Select,
} from '@material-ui/core';

// Helper
import {removeEmptyValueObject, flattenObject} from '../../../../utils/helpers';

// Type
import {SelectorProps, Props} from '../interfaces';
import Pagination from '@material-ui/lab/Pagination';
import classes from './index.module.scss';
import {GetInventoryFlowRequestBuilder} from 'client-sdk/src/skus/skus';
import handleError from '../../../../utils/handleError';
import Client from 'client-sdk/src/client';
import warehouseRepository from 'client-sdk/src/Repository/warehouses-repository';
import skuRepository from 'client-sdk/src/Repository/skus-repository';
import ReportList from './reportList';
import useQuery from '../../../../utils/hook/useQuery';
import {makeSelectSkusInventoryList} from '../../../warehouses/selectors';
import RonadIcons from '../../../../components/iconComponent';

export function InventoryDetailsMobile(props: Props) {
  const [value, setValue] = useState(0);
  const [reportList, setReportList] = useState<any>(null);
  const {filtersValues, setFiltersValues} = useQuery({
    page: 0,
    size: 10,
  } as any);
  const [openSizeReport, setOpenSizeReport] = React.useState(false as boolean);
  const [sku, setSku] = useState(null);
  const [inventory, setInventory] = useState({} as any);
  const token = localStorage.getItem('token') || '';

  const fetchReportList = async (id: number, args?: Record<string, any>) => {
    try {
      const request = new GetInventoryFlowRequestBuilder()
        .id(id)
        .params({
          ...removeEmptyValueObject(flattenObject(filtersValues)),
          ...args,
        })
        .build();
      const client = new Client(token);
      const {data} = await client.execute(request);
      setReportList(data);
    } catch (err) {
      handleError(err);
    }
  };

  const getWarehouseInventory = async (actions: any) => {
    const payload = {...actions};
    try {
      const response = await warehouseRepository.getWarehouseInventory({
        payload,
      });
      const result = response.data[0];
      setInventory(result);
    } catch (error) {
      handleError(error);
    }
  };

  const getItem = async () => {
    const payload = {pagination: {'id.equals': props.match.params.id}};
    try {
      const response = await skuRepository.getSkusInventory({
        payload,
      });
      setSku(response.data.content[0]);
    } catch (error) {
      handleError(error);
    }
  };
  useEffect(() => {
    getItem();
    getWarehouseInventory({'variantId.equals': props.match.params.id});
  }, []);
  useEffect(() => {
    fetchReportList(props.match.params.id);
    props.getParcelInventoryItemDispatch({
      ...filtersValues,
    });
  }, [filtersValues]);

  const handleChangeSizeReportList = (
    event: React.ChangeEvent<{value: unknown}>
  ) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
    fetchReportList(props.match.params.id, {
      ...filtersValues,
      size: event.target.value,
    });
  };
  const handleChangeReportPage = (
    _: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
    fetchReportList(props.match.params.id, {...filtersValues, page: page - 1});
  };

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const TabPanel = (props: any) => {
    const {children, value, index, ...other} = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  };
  return (
    <div className={classes.root}>
      <Box className={classes.tabs}>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
        >
          <Tab label="موجودی انبار" {...a11yProps(0)} />
          <Tab label="اطلاعات کالا" {...a11yProps(1)} />
          <Tab label="تاریخچه" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <Grid
        className={classes.topBox}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={0}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '83%',
            borderRadius: '0',
            padding: '0 10px',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              {`
        جزيیات 
         `}
              <span data-cy="parcelId"> {sku?.id}</span>
            </Typography>
          </div>
          <Link to={`edit/${sku?.id}/${sku?.warehouseId}`}>
            <button
              aria-label="edit"
              size="small"
              title="ویرایش"
              data-cy="edit"
              className={classes.editBtn}
            >
              <RonadIcons name='pencil' />
            </button>
          </Link>
        </Paper>
      </Grid>

      <Grid item lg={12} md={12} style={{marginBottom: '32px'}}>
        <TabPanel value={value} index={0}>
          <Card className={classes.card}>
            <CardContent style={{paddingBottom: '0'}}>
              <Grid xs={12} sm={12} lg={12}>
                <div className={classes.countBox}>
                  <h2>{inventory?.located}</h2>
                  <p>موجودی شلف</p>
                </div>
              </Grid>
              <Grid xs={12} sm={12} lg={12}>
                <div className={classes.countBox}>
                  <h2>{inventory?.orderable}</h2>
                  <p>موجودی</p>
                </div>
              </Grid>
              <Grid xs={12} sm={12} lg={12}>
                <div className={classes.countBox}>
                  <h2>{inventory?.orderable}</h2>
                  <p>موجودی غیرقابل سفارش (ضایعات)</p>
                </div>
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات موجودی انبار
                </Typography>
              }
            />
            <CardContent style={{paddingBottom: '0'}}>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نام کالا:  '}</span>
                  <span data-cy="parcelStatus">{sku?.productName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'موجودی قابل سفارش:  '}
                  </span>
                  <span data-cy="parcelStatus">{sku?.orderable}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'کد کالا:  '}</span>
                  <span data-cy="parcelSellerName">{sku?.productCode}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شناسه کالا:  '}</span>
                  <span data-cy="parcelSellerName">{sku?.productId}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'کد تنوع:  '}</span>
                  <span data-cy="parcelSellerName">{sku?.code}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شناسه تنوع:  '}</span>
                  <span data-cy="parcelSellerName">{sku?.id}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'فروشنده/تامین کننده:  '}
                  </span>
                  <span data-cy="parcelSellerName">
                    {sku?.providerName ?? sku?.sellerName}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {' کد فروشنده/تامین کننده:  '}
                  </span>
                  <span data-cy="parcelSellerName">
                    {sku?.providerCode ?? sku?.sellerCode}
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Card className={classes.card} style={{padding: '0'}}>
            <CardContent style={{padding: '0'}}>
              <ReportList data={reportList?.content} />
              <Grid container>
                <Grid item xs={6} sm={6}>
                  <FormControl
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                      {' '}
                      تعداد نمایش در هر صفحه:
                    </div>
                    <Select
                      open={openSizeReport}
                      onClose={() => setOpenSizeReport(false)}
                      onOpen={() => setOpenSizeReport(true)}
                      value={filtersValues.size}
                      onChange={handleChangeSizeReportList}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid xs={6} sm={6} container item direction="row-reverse">
                  <Pagination
                    className={classes.pagination}
                    count={Math.ceil(
                      reportList?.totalElements / filtersValues.size
                    )}
                    color="secondary"
                    page={filtersValues?.page + 1}
                    onChange={handleChangeReportPage}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  skusInventoryList: makeSelectSkusInventoryList(),
  parcel: makeSelectParcel(),
  loading: makeSelectLoading(),
  inventoryItemsCount: makeSelectInventoryItemsCount(),
  inventoryItemsWithSerial: makeSelectInventoryItemsWithSerialList(),
  inventoryItemsWithSerialLoading: makeSelectInventoryItemsWithSerialLoading(),
  error: makeSelectError(),
  inventoryItems: makeSelectInventoryItemsList(),
  inventoryItemsLoading: makeSelectInventoryItemsLoading(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({id})),

    getParcelWithIdActionDispatch: (id: number) =>
      dispatch(getParcelsWithIdAction({id})),
    getParcelInventoryItemDispatch: (payload: object) =>
      dispatch(getParcelInventoryItemsAction(payload)),
    clearnParcelInventoryItemsDispatch: () =>
      dispatch(cleanPercelInventoryItemsAction()),
    getInventoryItemsWithSerialActionDispatch: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithSerialAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(InventoryDetailsMobile);
